import { render, staticRenderFns } from "./FieldPermissionDelete.vue?vue&type=template&id=6882b0aa"
import script from "./FieldPermissionDelete.vue?vue&type=script&lang=js"
export * from "./FieldPermissionDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports